import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_InputText = _resolveComponent("InputText")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "p-datatable-sm kn-table p-m-2",
    paginator: true,
    rows: 10,
    value: _ctx.rows,
    loading: _ctx.loading,
    filters: _ctx.filters,
    "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
    selection: _ctx.selectedValues,
    "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedValues = $event)),
    selectionMode: ['CONTAINS', 'NOT CONTAINS', 'IN', 'NOT IN'].includes(_ctx.filterOperator) ? false : 'single',
    filterDisplay: "menu",
    responsiveLayout: "stack",
    breakpoint: "960px",
    onRowSelect: _ctx.onSelect,
    onRowUnselect: _ctx.onSelect,
    onRowSelectAll: _ctx.onSelectAll,
    onRowUnselectAll: _ctx.onSelectAll
  }, {
    empty: _withCtx(() => [
      _createVNode("div", null, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        selectionMode: ['CONTAINS', 'NOT CONTAINS', 'IN', 'NOT IN'].includes(_ctx.filterOperator) ? 'multiple' : 'single',
        headerStyle: _ctx.QBEFilterDialogDescriptor.selectionColumnHeaderStyle
      }, null, 8, ["selectionMode", "headerStyle"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
        return (_openBlock(), _createBlock(_component_Column, {
          key: column.header,
          field: column.dataIndex,
          header: column.header,
          sortable: true
        }, {
          filter: _withCtx(({ filterModel }) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              class: "p-column-filter"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 2
        }, 1032, ["field", "header"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "loading", "filters", "selection", "selectionMode", "onRowSelect", "onRowUnselect", "onRowSelectAll", "onRowUnselectAll"]))
}